import { PdGenericForm } from "./pd-generic-form/PdGenericForm.js";
//#region src/pd-generic-form/pd-generic-form.ts
var tag = "pd-generic-form";
if (!customElements.get(tag)) customElements.define(tag, PdGenericForm);
//#endregion
export { PdGenericForm };
